import {Component} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {TranslocoDirective} from "@jsverse/transloco";

@Component({
  selector: 'app-public-contact',
  imports: [
    ReactiveFormsModule,
    TranslocoDirective
  ],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss'
})
export class ContactComponent {
}
